/**
 * How a side panel glides in and out.
 *
 * Three things have to line up for the animation to run at all:
 *  - the CSS duration in styles/base/sidebar.scss;
 *  - `timeout`, because PrimeReact's CSSTransition *unmounts* the panel when it elapses (default
 *    300ms), so a longer CSS duration alone just gets the exit chopped off; and
 *  - `appear`, which is the one that actually matters here. Most panels are mounted only once they
 *    are open (the useCreateXSidebar hooks return null until there is a request), and PrimeReact
 *    sets maskVisible+visible in a single setState on mount — so CSSTransition's first render
 *    already has `in: true`. react-transition-group runs no enter animation in that case; without
 *    `appear` those panels simply pop into place.
 *
 * Every <Sidebar> in the app passes `transitionOptions={sidebarTransitionOptions}`.
 */
export const SIDE_MODAL_TRANSITION_MS = 400;

export const sidebarTransitionOptions = { timeout: SIDE_MODAL_TRANSITION_MS, appear: true };
